import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { AuthProvider } from "../AuthContext";
import Login from "./Login";
import SignUp from "./SignUp";
import CheckStatus from "./CheckStatus";
function App() {
    return (_jsx(AuthProvider, { children: _jsx(Router, { children: _jsxs(Switch, { children: [_jsx(Route, { path: "/", exact: true, component: Login }, void 0), _jsx(Route, { path: "/signup", exact: true, component: SignUp }, void 0), _jsx(Route, { path: "/checkstatus", exact: true, component: CheckStatus }, void 0)] }, void 0) }, void 0) }, void 0));
}
export default App;



//////////////////
// WEBPACK FOOTER
// ./src/pages/App.tsx
// module id = 41
// module chunks = 0